jQuery(function ($) {
    $(document).ready(function () {
        
        const getFilterValue = function(filterName) {
            let values = [];
            $('input.' + filterName + '-checked').each(function(index, checkbox)  {
                if(($(checkbox).is(':checked')) ) {
                    values.push($(this).val());
                }
            });

            return values;
        };

        // Gestion des clicks sur les dropdowns
        $('.input-group.dropdown a').each(function(){
            $(this).on(('click'), function(event) {
                event.preventDefault();
                $(this).toggleClass('active');
                $(this).next('.multiSelect').toggleClass('active');
            });
        });

        // Gestion des multiselects 
        let productList = document.querySelector('#ludi_posts_wrap');
        if(productList) {
            $('#loading').show();
            // Declaration des variables
            let busy = true;
            let page = 0;
            let limit = 9;
            let end = false;
            let filter = {
                "age": getFilterValue('age'),
                "gamme": getFilterValue('gamme'),
                'new': getFilterValue('new'),
                'discount': getFilterValue('discount')
            };

            $.ajax({
                url: ajaxurl,
                method: 'POST',
                data: {
                    action: "get_product",
                    params: {
                        "page": page,
                        "limit": limit,
                        "filter": filter,
                    }
                },
                success: function(data) {
                    if(data.success) {
                        // InnerHTML
                        productList.innerHTML = data.data.html;
                        // N'est plus occupé
                        busy = false;
                        $('#loading').hide();
                    } else {
                        productList.innerHTML = "Pas de correspondance...";
                        // Error
                        end = true;
                        $('#loading').hide();
                    }
                }
            });

            //EVENT SCROLL
            $(window).bind('scroll', function() {
                // Si on est en bas de la div et qu'on a pas atteint le nombre max de post
                if($(window).scrollTop() >= $('#ludi_posts_wrap').offset().top + $('#ludi_posts_wrap').outerHeight() - window.innerHeight && !end) {

                    // Si il n'y a pas de chargement
                    if(!busy) {
                        // On previent que ça charge
                        busy = true;
                        // Image de chargement
                        $('#loading').show();
                        // On incrémente la page
                        page++;
                        // On va chercher les posts
                        $.ajax({
                            url: ajaxurl,
                            method: 'POST',
                            data: {
                                action: "get_product",
                                params: {
                                    "page": page,
                                    "limit": limit,
                                    "filter": filter
                                }
                            },
                            success: function(data) {
                                if(data.success) {
                                    // On ajoute les posts en plus
                                    productList.innerHTML += data.data.html;
                                    // On previent qu'on a fini le chargement
                                    if(data.data.html == "") {
                                        end = true;
                                        busy = false;
                                        $('#loading').hide();
                                    }
                                    busy = false;
                                    $('#loading').hide();
                                } else {
                                    end = true;
                                    $('#loading').hide();
                                }
                            }
                        });
                    }
                }
            });
            // GESTION DES FILTRES DROPDOWN 
            $('.input-group.multiSelect').on('change', 'input:checkbox', function() {  
                filter.age=[];
                filter.gamme=[];
                busy = true;
                productList.innerHTML = "";
                $('#loading').show();
                page = 0;
                end = false;    

                filter.age = getFilterValue('age');
                filter.gamme = getFilterValue('gamme');

                $.ajax({
                    url: ajaxurl,
                    method: 'POST',
                    data: {
                        action: "get_product",
                        params: {
                            "page": page,
                            "limit": limit,
                            "filter": filter
                        }
                    },
                    success: function(data) {
                        if(data.success) {
                            // On ajoute les posts en plus
                            productList.innerHTML = data.data.html;
                            if(data.data.html == "") {
                                productList.innerHTML = "Pas de correspondance...";
                                end = true;
                            }
                            // On previent qu'on a fini le chargement
                            busy = false;
                            $('#loading').hide();
                        } else {
                            productList.innerHTML = "Pas de correspondance...";
                            // Error
                            end = true;
                            $('#loading').hide();
                        }
                    }
                });

            });

            // GESTION DES FILTRES CASES A COCHER
            $('.product-filters-input').on('change', 'input:checkbox', function() {
                filter.new = [];
                filter.discount = [];

                busy = true;
                productList.innerHTML = "";
                $('#loading').show();
                
                page = 0;
                end = false; 

                filter.new = getFilterValue('new');
                filter.discount = getFilterValue('discount');

                $.ajax({
                    url: ajaxurl,
                    method: 'POST',
                    data: {
                        action: "get_product",
                        params: {
                            "page": page,
                            "limit": limit,
                            "filter": filter
                        }
                    },
                    success: function(data) {
                        if(data.success) {
                            // On ajoute les posts en plus
                            productList.innerHTML = data.data.html;
                            if(data.data.html == "") {
                                productList.innerHTML = "Pas de correspondance...";
                                end = true;
                            }
                            // On previent qu'on a fini le chargement
                            busy = false;
                            $('#loading').hide();
                        } else {
                            productList.innerHTML = "Pas de correspondance...";
                            // Error
                            end = true;
                            $('#loading').hide();
                        }
                    }
                });

            });

        }
    });
});